/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Weekday } from '../../types/date';
export type billing_TariffRateRequest = {
    /**
     * AgeType (BABY or CHILD) (required)
     */
    age_type: billing_TariffRateRequest.age_type;
    /**
     * DailyRate in Rappen (required)
     */
    daily_rate?: number;
    /**
     * DayOfWeek (1=Monday, 7=Sunday) (required)
     * enum: 1,2,3,4,5,6,7
     * minimum: 1
     * maximum: 7
     */
    day_of_week?: Weekday;
    /**
     * IsExtraDay indicates if this is an extra day rate
     */
    is_extra_day?: boolean;
    /**
     * ServiceCode identifies the service (required)
     */
    service_code: string;
    /**
     * Subsidised indicates if this is a subsidised rate
     */
    subsidised?: boolean;
};
export namespace billing_TariffRateRequest {
    /**
     * AgeType (BABY or CHILD) (required)
     */
    export enum age_type {
        BABY = 'BABY',
        CHILD = 'CHILD',
    }


}